import { defineMessages } from 'react-intl-next';

export const messages: {
	sizeLargeDropDownItemLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sizeMediumDropDownItemLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sizeSmallDropDownItemLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sizeTextLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	sizeTextLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.size-text-label',
		defaultMessage: 'Size',
		description: 'A visible text label for the size section of the link cards config panel',
	},
	sizeSmallDropDownItemLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label',
		defaultMessage: 'Small',
		description:
			'A visible label for the select option/selection/item to change card size to small for link card',
	},
	sizeMediumDropDownItemLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label',
		defaultMessage: 'Medium',
		description:
			'A visible label for the select option/selection/item to change card to size to medium for link card',
	},
	sizeLargeDropDownItemLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label',
		defaultMessage: 'Large',
		description:
			'A visible label for the select option/selection/item to change card to size to large for link card',
	},
});
